import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Select from "react-select";
import SlidePanel from "../shared/SlidePanel";
import toast from "../shared/Toast";
import siteSetting from "../../config/env";
import { marketingAction } from "../../_actions/marketing.actions";
import { ChannelCards, getSmsText, SALES_PREVIEW, marketingSelectProps } from "./MarketingEditorParts";

const NUM_REGEX = /^[0-9\b]+$/;

function SalesPanel({ data, salonId, onClose, onSaved }) {
  const dispatch = useDispatch();
  const isRebook = data?.type === 1;
  const [reminder, setReminder] = useState({ ...data });
  const [reminderTime, setReminderTime] = useState(
    data?.reminderTime != null ? String(data.reminderTime) : ""
  );
  const [timeOption, setTimeOption] = useState(
    isRebook && data?.reminderTimeType
      ? { value: data.reminderTimeType, label: marketingAction.reminderTimeType(data.reminderTimeType) }
      : null
  );
  const [triggerError, setTriggerError] = useState(null);
  const [timeError, setTimeError] = useState(null);
  const [saving, setSaving] = useState(false);

  const options = siteSetting?.reminderTimeOptions;
  const map = SALES_PREVIEW[data?.type] || SALES_PREVIEW[1];

  const onTimeChange = (e) => {
    const v = e.target.value;
    if (v === "" || NUM_REGEX.test(v)) {
      setTriggerError(null);
      setReminderTime(v);
    } else {
      setTriggerError("Enter valid time in number.");
    }
  };

  const setStatus = (field, checked) =>
    setReminder((r) => ({ ...r, [field]: checked ? 1 : 0 }));

  const save = () => {
    const next = { ...reminder };
    if (isRebook) {
      if (+reminderTime <= 0) {
        setTriggerError("Trigger Time is required.");
        return;
      }
      if (!timeOption) {
        setTimeError("This field is required.");
        return;
      }
      next.reminderTime = +reminderTime;
      next.reminderTimeType = timeOption.value;
    }
    const payload = { reminders: [next], type: 4, salonId };
    setSaving(true);
    dispatch(marketingAction.updateSetting(payload))
      .then((res) => {
        setSaving(false);
        if (res?.data?.statusCode === 1) {
          toast.success(res?.data?.responseData?.message);
          if (onSaved) onSaved();
        }
      })
      .catch(() => setSaving(false));
  };

  const footer = (
    <>
      <button type="button" className="sp-btn-secondary" onClick={onClose}>
        Cancel
      </button>
      <button type="button" className="sp-btn-primary" onClick={save} disabled={saving}>
        Save
      </button>
    </>
  );

  return (
    <SlidePanel title={data?.title} onClose={onClose} footer={footer} width={520}>
      <p className="sp-hint" style={{ marginTop: 0, textAlign: "center" }}>
        {data?.note}
      </p>

      {isRebook && (
        <div className="mkt-time-row" style={{ marginTop: 16, marginBottom: 4 }}>
          <div className="mkt-time-trigger">
            <label className="sp-label">Trigger Time</label>
            <input
              type="text"
              className="sp-input"
              style={{ textAlign: "center" }}
              value={reminderTime}
              onChange={onTimeChange}
            />
            {triggerError ? <div className="sp-error">{triggerError}</div> : null}
          </div>
          <div className="mkt-time-frame">
            <label className="sp-label">Timeframe</label>
            <Select
              value={timeOption}
              options={options}
              onChange={(e) => {
                setTimeOption(e);
                setTimeError(null);
              }}
              {...marketingSelectProps}
            />
            {timeError ? <div className="sp-error">{timeError}</div> : null}
          </div>
        </div>
      )}

      <ChannelCards
        smsDesc={
          <>
            SMS messages are sent to <b>all clients</b> to the phone number you have
            saved on client record.
          </>
        }
        emailDesc={
          <>
            Emails are sent to <b>all clients</b> to the email address you have saved on
            their client record.
          </>
        }
        statusSMS={reminder?.statusSMSreminder}
        statusEmail={reminder?.statusEmailReminder}
        onToggleSms={(c) => setStatus("statusSMSreminder", c)}
        onToggleEmail={(c) => setStatus("statusEmailReminder", c)}
        smsText={getSmsText(map.sms)}
        emailType={map.email}
      />
    </SlidePanel>
  );
}

export default SalesPanel;
